import { APIResponseType } from 'app/apiService/types';
import apiService from 'app/apiService';
import { UnsoldLeadDetailsResponse, UnsoldLeadDetails } from '../types';

class UnsoldLeadDetailsApiService {
  static ENDPOINT = 'api/v2/leads/unsold';

  private static mockLeadDetails: UnsoldLeadDetails = {
    _id: '1',
    name: 'Johana Delgado',
    email: 'J****t@gmail.com',
    phone: '310-***-**01',
    lead_created_date: '1 January 2026',
    status: '2 - Lost',
    source: 'Website',
    voi_name: '2025 Toyota Rav4',
    lead_intelligence:
      'Johana Delgado is a likely Compact SUV buyer, with a likely budget of $30-$35,000. Her primary interest appears to focus on a vehicle that emphasizes reliability and value, with a likely preference for Japanese brands.',
    suggested_strategy:
      'Johana demonstrates mid-stage evaluation signals, suggesting mid-term purchase intent; personalized outreach or exclusive offers on popular compact SUVs could effectively advance her toward a decision. Consider targeting her with tailored promotions on in-demand SUVs and escalating to sales to capitalize on her engagement.',
  };

  static async getLeadDetails(leadId: string, dealerId: string, conversationId?: string): Promise<APIResponseType<UnsoldLeadDetailsResponse>> {
    try {
      let url = `${this.ENDPOINT}/${leadId}?dealer_id=${dealerId}`;
      if (conversationId) {
        url += `&conversation_id=${conversationId}`;
      }
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching lead details:', error);
      throw error;
    }
  }

}

export default UnsoldLeadDetailsApiService;

